import { Backdrop } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const GlobalLoaderBackdrop = styled(Backdrop)(({ theme }) => ({
  color: theme.palette.background.navigation,
  zIndex: '5000',
  margin: '0 !important',
}));
